"use client"

import Link from "next/link"
import { Package } from "lucide-react"
import { Button } from "@/components/ui/button"
import { LanguageSwitcher } from "@/components/providers/language-switcher";
import { useRole } from "@/contexts/role-context";
import { APP_NAME } from "@/lib/app-config";

interface SiteHeaderProps {
    dict: {
        register: string;
        login: string;
    };
    currentLang: string;
}

export function SiteHeader({ dict, currentLang }: SiteHeaderProps) {
    const { isAuthenticated, user } = useRole()

    const dashboardLink = isAuthenticated && user 
        ? `/${currentLang}/dashboard/${user.role.toLowerCase()}` 
        : null

    return (
        <nav className="border-b bg-background/80 backdrop-blur-sm sticky top-0 z-50">
            <div className="container mx-auto px-4 py-4 flex items-center justify-between">
                <Link href={`/${currentLang}`} className="flex items-center gap-3">
                    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                        <Package className="h-6 w-6" />
                    </div>
                    <span className="typo-brand-title">{APP_NAME}</span>
                </Link>

                <div className="flex items-center gap-4">

                    <Button variant="outline" size="sm" className="rounded-full px-4" asChild>
                        <Link href={dashboardLink || `/${currentLang}/register`}>
                            {dict.register}
                        </Link>
                    </Button>

                    <Button variant="default" size="sm" className="rounded-full px-4" asChild>
                        <Link href={dashboardLink || `/${currentLang}/login`}>
                            {dict.login}
                        </Link>
                    </Button>

                    <div className="mr-2">
                        <LanguageSwitcher currentLang={currentLang} availableLanguages={["ro", "en", "de"]} />
                    </div>
                </div>
            </div>
        </nav>
    )
}